export const COLOURS = {
  primary: {
    black: "#000000",
    white: "#FFFFFF",
  },
};

export const BORDERS = {
  primary: "rgba(255, 255, 255, 0.4)",
  secondary: "rgba(0, 0, 0, 0.4)",
};
